import { AxiosError } from 'axios'
import { defineStore } from 'pinia'
import type { QueriesGetPlansResponse } from 'client'
import { STORE } from '~/constants/strings'
import { HNRV2 } from '~/helpers'
import { api } from '~/services'

interface PlansState {
  plans: QueriesGetPlansResponse
}

export const usePlansStore = defineStore(STORE.PLANS, {
  state: (): PlansState => ({
    plans: {
      allPlans: [],
      message: '',
      mostRecentPlan: {
        planID: '',
        company: '',
        establishment: '',
        planCode: '',
        planDate: '',
        planName: '',
        planType: -1,
        publishDate: '',
        updatePlan: false,
      },
      mostRecentPlans: [],
    },
  }),
  getters: {
    hasPlans: (state): boolean => state.plans.allPlans.length > 0,
    isEmpty: (state): boolean => state.plans.allPlans.length === 0,
  },
  actions: {
    async getPlans(): Promise<void> {
      const response = await HNRV2({
        fn: () => api.plans.apiPlansGet(),
      })

      if (response instanceof AxiosError) {
        return
      }

      this.plans = response
    },
  },
})
